(() => {
  if (customElements.get('apex-capture-gallery')) return;
  customElements.define('apex-capture-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const videos = [...this.querySelectorAll('video')];
      videos.forEach(video => video.addEventListener('play', () => {
        videos.forEach(other => { if (other !== video) other.pause(); });
      }, options));
      const dialog = this.querySelector('dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const image = dialog.querySelector('[data-apex-enlarged-photo]');
      const caption = dialog.querySelector('figcaption');
      this.querySelectorAll('[data-apex-capture-photo]').forEach(link => {
        link.addEventListener('click', event => {
          if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          const thumbnail = link.querySelector('img');
          image.src = link.href;
          image.alt = thumbnail?.alt || link.dataset.caption || '';
          image.width = thumbnail?.naturalWidth || 2560;
          image.height = thumbnail?.naturalHeight || 1440;
          caption.textContent = link.dataset.caption || '';
          this.lastPhotoLink = link;
          if (!dialog.open) dialog.showModal();
        }, options);
      });
      dialog.querySelector('button').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, options);
      dialog.addEventListener('close', () => {
        image.removeAttribute('src');
        this.lastPhotoLink?.focus();
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.querySelectorAll('video').forEach(video => video.pause());
      const dialog = this.querySelector('dialog');
      if (dialog?.open) dialog.close();
    }
  });
})();
